/* ================================================== *\
 * Model to store various facts about a residence.
\* ================================================== */

import { Model } from '@vuex-orm/core';
import Residence from '@/models/Residence';

export default class Facts extends Model {
  static entity = 'facts';

  static fields() {
    return {
      id: this.uid(),

      floor: this.attr(null),
      size: this.number(null),
      floorSize: this.number(null),
      grossSize: this.number(null),
      bedrooms: this.attr(null),
      bathrooms: this.attr(null),
      storage: this.attr(null),
      garden: this.attr(null),
      lotsize: this.attr(null),
      terrace: this.attr(null),
      balcony: this.attr(null),
      glazed_balcony: this.attr(null),
      garage: this.attr(null),
      carport: this.attr(null),
      parking: this.attr(null),

      // Relationship IDs
      residence_id: this.attr(null),

      // Relationships
      residence: this.belongsTo(Residence, 'residence_id'),
    };
  }
}
